import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-matrix',
    templateUrl: './matrix.component.html',
    styleUrls: ['./matrix.component.css']
})
export class MatrixComponent implements OnInit, OnDestroy {

    impactSelected: number;
    urgencySelected: number;
    prioritySelected: number;
    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    impacts = [];
    urgencies = [];
    impactName: string;
    urgencieName: string;
    priorities = [];


    displayData: any;

    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    private clientId: number;
    private priorityName: any;

    public categories: any;
    public categorySelected: number;
    private categoryName: any;
    type: string;
    tickets = [];
    ticketSelected: number;
    priorityType: number;
    masterNameObj = [];
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private userAuth: Subscription;
    private baseFlag: any;
    offset: number;
    dataLoaded: boolean;
    showSearch = true;
    isLoading = false;
    catSelected: any;

    matrix: any;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;

    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {

                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteBusinessMatrix({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        // this.messageService.getUserAuth().subscribe(details => {
        //   console.log(JSON.stringify(details));
        //   if (details.length > 0) {
        //     this.add = details[0].addFlag;
        //     this.del = details[0].deleteFlag;
        //     this.view = details[0].viewFlag;
        //     this.edit = details[0].editFlag;
        //   } else {
        //     this.add = true;
        //     this.del = true;
        //     this.view = true;
        //     this.edit = true;
        //   }
        // });
    }


    ngOnInit() {
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Business Matrix',
            openModalButton: 'Add Business Matrix',
            searchModalButton: 'Search',
            breadcrumb: 'BusinessMatrix',
            folderName: 'All Business Matrix',
            tabName: 'Business Matrix',
            exportBtn: 'Export to excel'

        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'impact', name: 'Impact ', field: 'impact', sortable: true, filterable: true
            },
            {
                id: 'urgency', name: 'Urgency ', field: 'urgency', sortable: true, filterable: true
            },
            {
                id: 'priority', name: 'Priority ', field: 'priority', sortable: true, filterable: true
            },
            {
                id: 'category', name: 'Category ', field: 'category', sortable: true, filterable: true
            },
            {
                id: 'type', name: 'Type ', field: 'ticket_type', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }

    }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.tickets = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            alert(this.messageService.SERVER_ERROR);
        });

        // this._rest.getBusinessUrgency(this.clientId).subscribe((res1) => {
        //   this.respObject = res1;
        //   if (this.respObject.success) {
        //     this.isError = false;
        //     this.respObject.details.unshift({id: 0, name: 'Select Urgency'});
        //     this.urgencies = this.respObject.details;
        //     this.urgencySelected = 0;
        //   } else {
        //     this.isError = true;
        //     this.errorMessage = this.respObject.errorMessage;
        //   }
        // }, (err) => {
        //   this.isError = true;
        //   this.errorMessage = this.messageService.SERVER_ERROR;
        // });
        // this._rest.getBusinessImpact(this.clientId).subscribe((res1) => {
        //   this.respObject = res1;
        //   if (this.respObject.success) {
        //     this.isError = false;
        //     this.respObject.details.unshift({id: 0, name: 'Select Impact'});
        //     this.impacts = this.respObject.details;
        //     this.impactSelected = 0;
        //   } else {
        //     this.isError = true;
        //     this.errorMessage = this.respObject.errorMessage;
        //   }
        // }, (err) => {
        //   this.isError = true;
        //   this.errorMessage = this.messageService.SERVER_ERROR;
        // });
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    onImpactChange(selectedIndex) {
        this.impactName = this.impacts[selectedIndex].name;
    }


    exportToExcel() {
        this.isExportDisable = true;
        this._rest.getAllBusinessMatrix(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            var data = {};
            if (this.respObject.success) {
                const matrixArr = [];
                this.isExportDisable = false;
                this.dataExcel = this.respObject.details;
                for (let i = 0; i < this.dataExcel.length; i++) {
                    data['impact'] = this.dataExcel[i].impact;
                    data['urgency'] = this.dataExcel[i].urgency;
                    data['category'] = this.dataExcel[i].category;
                    data['priority'] = this.dataExcel[i].priority;
                    data['ticket_type'] = this.dataExcel[i].ticket_type;
                    matrixArr.push(data);
                }
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(matrixArr);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.impactSelected = 0;
            this.urgencySelected = 0;
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {
            });
        }
    }

    searchModal() {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.impactSelected = 0;
            this.urgencySelected = 0;
            this.catSelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
        }
    }

    search() {
        this._rest.searchAllBusinessMatrix(this.catSelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.matrix = this.respObject.details;
                this.messageService.setTotalData(this.matrix.length);
                this.messageService.setGridData(this.matrix);
                this.searchModalReference.close();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    save() {
        let data;
        if (this.priorityType === 1) {
            data = {
                clientId: this.clientId,
                busi_impact_id: this.impactSelected,
                busi_urgency_id: this.urgencySelected,
                busi_priority_id: this.prioritySelected,
                type: this.priorityType,
                ticket_type: this.ticketSelected,
                createdBy: this.messageService.getUserId()
            };
        } else {
            data = {
                clientId: this.clientId,
                categoryId: this.categorySelected,
                busi_priority_id: this.prioritySelected,
                type: this.priorityType,
                ticket_type: this.ticketSelected,
                createdBy: this.messageService.getUserId()
            };
        }
        if (!this.messageService.isBlankField(data)) {
            // console.log(JSON.stringify(data));
            this._rest.insertBusinessMatrix(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    const id = this.respObject.id;
                    if (this.priorityType === 1) {
                        this.messageService.setRow({
                            id: id,
                            urgency: this.urgencieName,
                            impact: this.impactName,
                            priority: this.priorityName,
                        });
                    } else {
                        this.messageService.setRow({
                            id: id,
                            priority: this.priorityName,
                            category: this.categoryName
                        });
                    }
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }
                    this.impactSelected = 0;
                    this.urgencySelected = 0;
                    this.prioritySelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getBusinessMatrix(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }


    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onUrgencyChange(selectedIndex: any) {
        this.urgencieName = this.urgencies[selectedIndex].name;
    }

    onCategoryChange(selectedIndex: any) {
        this.categoryName = this.categories[selectedIndex].name;
        // console.log(this.categoryName, this.categories[selectedIndex].id);
    }

    onPriorityChange(selectedIndex: any) {
        this.priorityName = this.priorities[selectedIndex].name;
    }


    onTicketChange(selectedIndex: any) {
        this.dataLoaded = false;
        this.type = this.tickets[selectedIndex].name;
        this._rest.getPriorityMapping(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.priorityType = this.respObject.details[0].ticket_priority_type;
                this.respObject.details[0].priority.unshift({id: 0, name: 'Select Priority'});
                this.priorities = this.respObject.details[0].priority;
                this.prioritySelected = 0;
                this.dataLoaded = true;
                if (this.priorityType === 2) {
                    this.respObject.details[0].category.unshift({id: 0, name: 'Select Category'});
                    this.categories = this.respObject.details[0].category;
                    this.categorySelected = 0;
                }
                if (this.priorityType === 1) {
                    this.respObject.details[0].urgency.unshift({id: 0, name: 'Select Urgency'});
                    this.urgencies = this.respObject.details[0].urgency;
                    this.urgencySelected = 0;
                    this.respObject.details[0].impact.unshift({id: 0, name: 'Select Impact'});
                    this.impacts = this.respObject.details[0].impact;
                    this.impactSelected = 0;
                }
            } else {
                this.dataLoaded = true;
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.dataLoaded = true;
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }
}
